/**
 * Lectura de la configuracion publica de la UI (`import.meta.env`).
 *
 * Solo variables con prefijo `VITE_`: todo lo que se lea aca termina en el
 * bundle y es publico. Ver `apps/monitor/.env.example`.
 */

/** Modo de autenticacion de la UI. */
export type AuthMode = 'google' | 'dev';

export interface UiEnvironment {
  /** Base de la API del middleware; en desarrollo la resuelve el proxy de Vite. */
  readonly apiBaseUrl: string;
  /** `google` = SSO real. `dev` = login local sin Google, solo para desarrollo. */
  readonly authMode: AuthMode;
  readonly googleClientId: string;
  readonly googleHostedDomain: string;
  /**
   * Etiqueta del ambiente: local | desarrollo | staging | produccion. La leen el
   * menu lateral, el titulo de la pestana y el favicon (ver `lib/environment.ts`).
   */
  readonly environmentLabel: string;
}

function text(value: string | undefined, fallback: string): string {
  const trimmed = (value ?? '').trim();
  return trimmed === '' ? fallback : trimmed;
}

/**
 * Resuelve la configuracion una vez, al arrancar.
 *
 * Un `VITE_AUTH_MODE` desconocido cae en `google`: preferimos exigir SSO antes
 * que abrir el login de desarrollo por un typo en el `.env`.
 */
export function readEnvironment(): UiEnvironment {
  const env = import.meta.env;
  return {
    apiBaseUrl: text(env.VITE_API_BASE_URL, '/api'),
    authMode: text(env.VITE_AUTH_MODE, 'google') === 'dev' ? 'dev' : 'google',
    googleClientId: text(env.VITE_GOOGLE_CLIENT_ID, ''),
    googleHostedDomain: text(env.VITE_GOOGLE_HOSTED_DOMAIN, ''),
    environmentLabel: text(env.VITE_ENVIRONMENT_LABEL, 'local'),
  };
}
